<template>
  <div>

    <!-- Probes chips & others -->
    <v-layout fluid style="vertical-align: middle;">

      <v-tooltip bottom open-delay="600ms" z-index="200">
        <template #activator="{ on }">
          <v-btn icon :color="show_background ? '#00AA00' : null"
                 :disabled=" corr_background "
                 @click="show_background = !show_background">
            <v-icon class="rotate-25">mdi-chart-sankey-variant mdi-flip-v</v-icon>
          </v-btn>
        </template>
        <span>Show probe background</span>
      </v-tooltip>

      <v-tooltip bottom open-delay="600ms" z-index="200">
        <template #activator="{ on }">
          <v-btn icon :color="corr_background ? '#00AA00' : null"
                 @click="corr_background = !corr_background">
            <v-icon>mdi-chart-sankey-variant mdi-flip-v</v-icon>
          </v-btn>
        </template>
        <span>Correction probe background</span>
      </v-tooltip>


      <!-- Probes' chips -->
      <v-flex fluid>
        <v-item-group v-model="selected_probes" multiple>
          <v-layout row justify-space-around center>
            <template v-for="probe in probe_items">
              <v-item :key="probe.id" :value="probe.id"
                      v-slot:default="{ active, toggle }">

                <v-tooltip bottom open-delay="600ms">
                  <template v-slot:activator="{ on }">
                    <v-scroll-y-transition>
                      <v-chip v-if="!active" v-on="on" @click="toggle"
                              :color="probe.color ? probe.color: probe.dye.color" outlined
                              style="margin: 2px;">
                        {{probe.dye.name}}
                      </v-chip>

                      <v-chip v-if="active" v-on="on" @click="toggle"
                              :color="probe.color ? probe.color : probe.dye.color"
                              style="color: white; margin: 2px;">
                        {{probe.dye.name}}
                      </v-chip>
                    </v-scroll-y-transition>
                  </template>
                  <div>
                    <div>id:{{probe.id}}</div>
                    <div>probe name: {{probe.name}}</div>
                  </div>
                </v-tooltip>

              </v-item>
            </template>

          </v-layout>
        </v-item-group>
      </v-flex>

      <!-- Reset chart zoom -->
      <v-tooltip bottom open-delay="600ms" style="z-index: 200;">
        <template v-slot:activator="{ on }">
          <v-btn icon ref="btnChartReset" @click="btnChartReset_click" v-on="on">
            <v-icon>mdi-magnify-scan</v-icon>
          </v-btn>
        </template>
        <span>Reset chart zoom</span>
      </v-tooltip>

    </v-layout>

    <v-layout>
      Sel.probes: {{selected_probes}}
      <!--      Sel.wells: {{selected_wells}}-->
      Hovered.well: {{hovered_well}}
    </v-layout>

    <plate-probe-chart
      ref="chartProbe" style="min-height: 600px;"
      :plate="plate" :disabled="disabled"
      :selected_wells="selected_wells"
      :selected_probes="selected_probes"
      :hovered_well="hovered_well"
      :show_background="show_background"
      :corr_background="corr_background"
    >
    </plate-probe-chart>

    <div style="background-color: #EEFFEE; text-align: center;">
      bottom border of Probes
    </div>

  </div>
</template>

<script
>

	import format from 'string-format'
	import {mdiMagnifyScan} from '@mdi/js'
	import {
		VLayout, VCard, VCardTitle, VCardText,
		VItemGroup, VItem, VChip,
		VScrollYTransition,
	} from 'vuetify'
	import PlateProbeChart from './charts/PlateProbeChart'
	import {Probe} from '../../models/Probe'
	import {Plate} from '../../models/Plate'


	export default {
		name: "plate-probe",

		components: {
			VLayout, VCard, VCardTitle, VCardText,
			VItemGroup, VItem, VChip,
			VScrollYTransition,
			'plate-probe-chart': PlateProbeChart,
		},

		data: function () {
			return {
				probe_items: [],
				selected_probes: [],

				show_background: false,
				corr_background: false,
				allow_multiple_probes: true,
			}
		},

		props: {
			disabled: {type: Boolean, default: false,},
			plate: {type: Object, default: () => null,},
			selected_wells: {type: Array, default: () => [],},
			hovered_well: {type: Number, default: -1,},
		},

		watch: {
			plate: function (new_value, old_value) {
				console.debug("PlateProbeComponent.watch.plate() ")

				this.selected_probes = Object.values(this.plate.probes)
					.map((p) => p.id)
			},

			selected_wells: function () {
				console.debug("PlateProbeComponent.watch.selected_wells()")

				this.update_view()
			},

			selected_probes: function (new_value, old_value) {
				this.$emit('selected_probes', this.selected_probes)
			},

			show_background: function (new_value, old_value) {
				console.debug(format("PlateProbeChart.watch.show_background( {0})", this.show_background))
			},

			corr_background: function (new_value, old_value) {
				console.debug(format("PlateProbeChart.watch.corr_backgrounf( {0} )", this.corr_background))
			},
		},

		mounted: function () {
			// console.log("PlateProbeComponent.mounted() ")

		},

		updated: function () {
			// console.log("PlateProbeComponent.updated() ")
		},

		methods: {

			update_view: function () {

				if (this.plate === Plate.empty_plate) {
					this.probe_items = []

				} else {
					const res2 = Object.values(this.plate.probes)
						.sort(Probe.compare_probes_by_dye_order)
					const probe_list = [...new Set(
						[].concat.apply([], this.selected_wells.map(
							(well_num) => this.plate.wells[well_num].probes))
					), -1000]
						.map((probe_id) => this.plate.probes[probe_id])
						.sort(Probe.compare_probes_by_dye_order)
					probe_list.pues

					this.probe_items = probe_list
				}
			},

			// -- Handle controls' events --

			btnChartReset_click: function (event) {
				this.$refs.chartProbe.reset()

				this.point = this.plate
					? this.plate.points.length
					: -1
			},

		}
	}
</script>


<style scoped>
  .rotate-25 {
    -webkit-transform: rotate(-25deg);
    -moz-transform: rotate(-25deg);
    -ms-transform: rotate(-25deg);
    -o-transform: rotate(-25deg);
    transform: rotate(-25deg);
  }

</style>